"use client";

// @components
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
} from "@/components/ui/breadcrumb";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { SidebarTrigger } from "@/components/ui/sidebar";

// @icons
import { Bell, Search } from "lucide-react";

// @hooks
import { usePathname } from "next/navigation";

export function AppNavbar() {
  const pathanme = usePathname();
  const pathAsArray = pathanme.split("/");
  const title = pathAsArray[pathAsArray.length - 1];

  return (
    <header className="flex shrink-0 items-center justify-between gap-2 p-4">
      <div className="flex items-center gap-2">
        <SidebarTrigger />
        <Separator
          orientation="vertical"
          className="mr-1.5 data-[orientation=vertical]:h-3.5"
        />
        <Breadcrumb>
          <BreadcrumbList>
            <BreadcrumbItem className="text-white capitalize">
              {title}
            </BreadcrumbItem>
          </BreadcrumbList>
        </Breadcrumb>
      </div>
      <div className="flex items-center gap-2">
        <Button
          variant="ghost"
          size="icon"
          className="h-7 w-7"
          aria-label="search"
        >
          <Search className="size-4" />
        </Button>
        <Button
          variant="ghost"
          size="icon"
          className="h-7 w-7"
          aria-label="notification"
        >
          <Bell className="size-4" />
        </Button>
      </div>
    </header>
  );
}
